// The RedesignNavbar is position:fixed (`fixed inset-x-0 top-0`) and ~72px tall. These class
// tokens are the single source of truth for that height, so page content offsets and sticky
// sub-navs stay in sync if the navbar height ever changes. Keep the `72px` literal here only.
// (Tailwind scans these literals to generate the matching utilities.)
// Push page content below the fixed navbar (use on the top-level content of non-hero pages).
export const REDESIGN_NAV_OFFSET_CLASS = 'pt-[72px]';
// Pin a sticky sub-nav (stepper, section nav) flush under the fixed navbar.
export const REDESIGN_NAV_STICKY_TOP_CLASS = 'top-[72px]';
